import React from 'react';
import ContainerContainer from './container.styles';
const Container = ({ children }) => {
    return <ContainerContainer>{children}</ContainerContainer>;
};
export default Container;
